import { State } from './state.type';

export const stateInitializer = (): State => ({
	rawBase64: null,
	aiBase64: null,
	canonical: 'raw',
	signature: '',
	rawChanged: false,
	aiChanged: false,
	dirty: false
});
